//default from angular libraries
import { Component } from '@angular/core';

//service 
import { GeneralService } from './services/general.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {

  constructor(
    private generalService: GeneralService
  ) {}
  
  ngOnInit() {
    
    this.generalService.routingChange();

  }

}
